import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import Footer from "../../components/Footer";
import ContactMain from "./ContactMain";

const Contact = () => {
  return (
    <>
      <HeaderFour />

      <ContactMain />

      <Footer />
    </>
  );
};

export default Contact;
